var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "modal custom",
        attrs: { id: "modal_confirm", role: "dialog" },
      },
      [
        _c(
          "div",
          {
            staticClass: "modal-dialog request-modal",
            class: { "wd-50": _vm.body_text === "default" },
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c(
                "div",
                { staticClass: "modal-body" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.reset()
                        },
                      },
                    },
                    [_vm._v("×")]
                  ),
                  _vm.body_text === "default"
                    ? [
                        _vm._m(0),
                        _c("div", [
                          _c(
                            "form",
                            { staticClass: "request-form" },
                            [
                              _c("div", { staticClass: "form-group" }, [
                                _vm._m(1),
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-md-8" },
                                    [
                                      _c("multiselect", {
                                        staticClass:
                                          "multiselect-single-dropdown",
                                        class: !_vm.selectedCountry
                                          ? "un-selected"
                                          : "",
                                        attrs: {
                                          placeholder: "Select Country",
                                          label: "country_name",
                                          searchable: true,
                                          "allow-empty": false,
                                          showLabels: false,
                                          editable: "false",
                                          options: _vm.countryList,
                                        },
                                        on: { select: _vm.onChangeCountry },
                                        model: {
                                          value: _vm.selectedCountry,
                                          callback: function ($$v) {
                                            _vm.selectedCountry = $$v
                                          },
                                          expression: "selectedCountry",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ]),
                              _vm._l(
                                _vm.smart_builder_templates,
                                function (template, index) {
                                  return _c(
                                    "div",
                                    { key: index, staticClass: "row pb-10" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-12 col-lg-12 pb-10",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(template.question) +
                                              " "
                                          ),
                                          _c(
                                            "span",
                                            { staticClass: "required" },
                                            [_vm._v("*")]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-12 col-lg-12 smartbuilder_tabs",
                                        },
                                        [
                                          _vm.activeTab
                                            ? [
                                                _c(
                                                  "div",
                                                  { staticClass: "tabs-left" },
                                                  [
                                                    _c(
                                                      "ul",
                                                      {
                                                        staticClass:
                                                          "nav nav-tabs",
                                                        attrs: {
                                                          role: "tablist",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "li",
                                                          {
                                                            staticClass:
                                                              "nav-item",
                                                            class: {
                                                              active:
                                                                _vm.activeTab ==
                                                                "european_union",
                                                            },
                                                            attrs: {
                                                              role: "presentation",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "nav-link",
                                                                attrs: {
                                                                  role: "tab",
                                                                  "data-toggle":
                                                                    "tab",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.activeTab =
                                                                        "european_union"
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "European Union"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "li",
                                                          {
                                                            staticClass:
                                                              "nav-item",
                                                            class: {
                                                              active:
                                                                _vm.activeTab ==
                                                                "usa_fda",
                                                            },
                                                            attrs: {
                                                              role: "presentation",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "nav-link",
                                                                attrs: {
                                                                  role: "tab",
                                                                  "data-toggle":
                                                                    "tab",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.activeTab =
                                                                        "usa_fda"
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "USA FDA"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "li",
                                                          {
                                                            staticClass:
                                                              "nav-item",
                                                            class: {
                                                              active:
                                                                _vm.activeTab ==
                                                                "latin_america",
                                                            },
                                                            attrs: {
                                                              role: "presentation",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "nav-link",
                                                                attrs: {
                                                                  role: "tab",
                                                                  "data-toggle":
                                                                    "tab",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      _vm.activeTab =
                                                                        "latin_america"
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Latin America"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.activeTab ===
                                                    "european_union",
                                                  expression:
                                                    "activeTab === 'european_union'",
                                                },
                                              ],
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "select_all" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "checkbox inline-checkbox",
                                                    },
                                                    [
                                                      _c("label", [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.selectAllEurope,
                                                              expression:
                                                                "selectAllEurope",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            checked:
                                                              Array.isArray(
                                                                _vm.selectAllEurope
                                                              )
                                                                ? _vm._i(
                                                                    _vm.selectAllEurope,
                                                                    null
                                                                  ) > -1
                                                                : _vm.selectAllEurope,
                                                          },
                                                          on: {
                                                            change: [
                                                              function (
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.selectAllEurope,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c =
                                                                    $$el.checked
                                                                      ? true
                                                                      : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v =
                                                                      null,
                                                                    $$i =
                                                                      _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      (_vm.selectAllEurope =
                                                                        $$a.concat(
                                                                          [$$v]
                                                                        ))
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      (_vm.selectAllEurope =
                                                                        $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          ))
                                                                  }
                                                                } else {
                                                                  _vm.selectAllEurope =
                                                                    $$c
                                                                }
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.templateIndex =
                                                                  index
                                                              },
                                                            ],
                                                          },
                                                        }),
                                                        _c("span", {
                                                          staticClass: "cr",
                                                        }),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-emergo-dark-blue ft-14 fw-500",
                                                    },
                                                    [_vm._v("Select all")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                _vm._l(
                                                  template.services
                                                    .european_union,
                                                  function (
                                                    service,
                                                    index_service
                                                  ) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index_service,
                                                        staticClass:
                                                          "form-check",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "mb-5",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "checkbox inline-checkbox",
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm
                                                                              .submitData
                                                                              .template_id_list,
                                                                          expression:
                                                                            "submitData.template_id_list",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      type: "checkbox",
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        service.id,
                                                                      checked:
                                                                        Array.isArray(
                                                                          _vm
                                                                            .submitData
                                                                            .template_id_list
                                                                        )
                                                                          ? _vm._i(
                                                                              _vm
                                                                                .submitData
                                                                                .template_id_list,
                                                                              service.id
                                                                            ) >
                                                                            -1
                                                                          : _vm
                                                                              .submitData
                                                                              .template_id_list,
                                                                    },
                                                                    on: {
                                                                      change: [
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          var $$a =
                                                                              _vm
                                                                                .submitData
                                                                                .template_id_list,
                                                                            $$el =
                                                                              $event.target,
                                                                            $$c =
                                                                              $$el.checked
                                                                                ? true
                                                                                : false
                                                                          if (
                                                                            Array.isArray(
                                                                              $$a
                                                                            )
                                                                          ) {
                                                                            var $$v =
                                                                                service.id,
                                                                              $$i =
                                                                                _vm._i(
                                                                                  $$a,
                                                                                  $$v
                                                                                )
                                                                            if (
                                                                              $$el.checked
                                                                            ) {
                                                                              $$i <
                                                                                0 &&
                                                                                _vm.$set(
                                                                                  _vm.submitData,
                                                                                  "template_id_list",
                                                                                  $$a.concat(
                                                                                    [
                                                                                      $$v,
                                                                                    ]
                                                                                  )
                                                                                )
                                                                            } else {
                                                                              $$i >
                                                                                -1 &&
                                                                                _vm.$set(
                                                                                  _vm.submitData,
                                                                                  "template_id_list",
                                                                                  $$a
                                                                                    .slice(
                                                                                      0,
                                                                                      $$i
                                                                                    )
                                                                                    .concat(
                                                                                      $$a.slice(
                                                                                        $$i +
                                                                                          1
                                                                                      )
                                                                                    )
                                                                                )
                                                                            }
                                                                          } else {
                                                                            _vm.$set(
                                                                              _vm.submitData,
                                                                              "template_id_list",
                                                                              $$c
                                                                            )
                                                                          }
                                                                        },
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.resetValues(
                                                                            index,
                                                                            index_service,
                                                                            "european_union"
                                                                          )
                                                                        },
                                                                      ],
                                                                    },
                                                                  }),
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "cr",
                                                                  }),
                                                                ]),
                                                              ]
                                                            ),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  service.name
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm.submitData.template_id_list.indexOf(
                                                          service.id
                                                        ) > -1
                                                          ? _vm._l(
                                                              service.questions,
                                                              function (
                                                                question,
                                                                question_index
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key: question_index,
                                                                    staticClass:
                                                                      "row ml-20 questions-row",
                                                                  },
                                                                  [
                                                                    question.type ===
                                                                      "checkbox" &&
                                                                    (!_vm.selectedCountry ||
                                                                      !question.not_for_countries.includes(
                                                                        _vm
                                                                          .selectedCountry
                                                                          .country_name
                                                                      ))
                                                                      ? [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "col-xs-12 pb-10",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "checkbox inline-checkbox",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "label",
                                                                                    [
                                                                                      _c(
                                                                                        "input",
                                                                                        {
                                                                                          directives:
                                                                                            [
                                                                                              {
                                                                                                name: "model",
                                                                                                rawName:
                                                                                                  "v-model",
                                                                                                value:
                                                                                                  question.answer,
                                                                                                expression:
                                                                                                  "question.answer",
                                                                                              },
                                                                                            ],
                                                                                          attrs:
                                                                                            {
                                                                                              type: "checkbox",
                                                                                              "true-value":
                                                                                                "Yes",
                                                                                              "false-value":
                                                                                                "-",
                                                                                            },
                                                                                          domProps:
                                                                                            {
                                                                                              checked:
                                                                                                Array.isArray(
                                                                                                  question.answer
                                                                                                )
                                                                                                  ? _vm._i(
                                                                                                      question.answer,
                                                                                                      null
                                                                                                    ) >
                                                                                                    -1
                                                                                                  : _vm._q(
                                                                                                      question.answer,
                                                                                                      "Yes"
                                                                                                    ),
                                                                                            },
                                                                                          on: {
                                                                                            change:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                var $$a =
                                                                                                    question.answer,
                                                                                                  $$el =
                                                                                                    $event.target,
                                                                                                  $$c =
                                                                                                    $$el.checked
                                                                                                      ? "Yes"
                                                                                                      : "-"
                                                                                                if (
                                                                                                  Array.isArray(
                                                                                                    $$a
                                                                                                  )
                                                                                                ) {
                                                                                                  var $$v =
                                                                                                      null,
                                                                                                    $$i =
                                                                                                      _vm._i(
                                                                                                        $$a,
                                                                                                        $$v
                                                                                                      )
                                                                                                  if (
                                                                                                    $$el.checked
                                                                                                  ) {
                                                                                                    $$i <
                                                                                                      0 &&
                                                                                                      _vm.$set(
                                                                                                        question,
                                                                                                        "answer",
                                                                                                        $$a.concat(
                                                                                                          [
                                                                                                            $$v,
                                                                                                          ]
                                                                                                        )
                                                                                                      )
                                                                                                  } else {
                                                                                                    $$i >
                                                                                                      -1 &&
                                                                                                      _vm.$set(
                                                                                                        question,
                                                                                                        "answer",
                                                                                                        $$a
                                                                                                          .slice(
                                                                                                            0,
                                                                                                            $$i
                                                                                                          )
                                                                                                          .concat(
                                                                                                            $$a.slice(
                                                                                                              $$i +
                                                                                                                1
                                                                                                            )
                                                                                                          )
                                                                                                      )
                                                                                                  }
                                                                                                } else {
                                                                                                  _vm.$set(
                                                                                                    question,
                                                                                                    "answer",
                                                                                                    $$c
                                                                                                  )
                                                                                                }
                                                                                              },
                                                                                          },
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "cr",
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        question.question
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                  question.required
                                                                                    ? _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "required",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "*"
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      : _vm._e(),
                                                                    question.type !==
                                                                      "checkbox" &&
                                                                    (!_vm.selectedCountry ||
                                                                      !question.not_for_countries.includes(
                                                                        _vm
                                                                          .selectedCountry
                                                                          .country_name
                                                                      ))
                                                                      ? [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "col-xs-12 pb-5 pr-0",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    question.question
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                              question.required
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "required",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "*"
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                          question.type ===
                                                                          "dropdown"
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-xs-12 col-sm-8 pr-0",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "multiselect",
                                                                                    {
                                                                                      staticClass:
                                                                                        "multiselect-single-dropdown",
                                                                                      class:
                                                                                        !question.answer
                                                                                          ? "un-selected"
                                                                                          : "",
                                                                                      attrs:
                                                                                        {
                                                                                          placeholder:
                                                                                            "Select Answer",
                                                                                          options:
                                                                                            question.values,
                                                                                          searchable: false,
                                                                                          "allow-empty": false,
                                                                                          showLabels: false,
                                                                                          editable:
                                                                                            "false",
                                                                                        },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            question.answer,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                question,
                                                                                                "answer",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                          expression:
                                                                                            "question.answer",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      : _vm._e(),
                                                                  ],
                                                                  2
                                                                )
                                                              }
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.activeTab === "usa_fda",
                                                  expression:
                                                    "activeTab === 'usa_fda'",
                                                },
                                              ],
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "select_all" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "checkbox inline-checkbox",
                                                    },
                                                    [
                                                      _c("label", [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.selectAllNorthAmerica,
                                                              expression:
                                                                "selectAllNorthAmerica",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            value: index,
                                                            checked:
                                                              Array.isArray(
                                                                _vm.selectAllNorthAmerica
                                                              )
                                                                ? _vm._i(
                                                                    _vm.selectAllNorthAmerica,
                                                                    index
                                                                  ) > -1
                                                                : _vm.selectAllNorthAmerica,
                                                          },
                                                          on: {
                                                            change: [
                                                              function (
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.selectAllNorthAmerica,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c =
                                                                    $$el.checked
                                                                      ? true
                                                                      : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v =
                                                                      index,
                                                                    $$i =
                                                                      _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      (_vm.selectAllNorthAmerica =
                                                                        $$a.concat(
                                                                          [$$v]
                                                                        ))
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      (_vm.selectAllNorthAmerica =
                                                                        $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          ))
                                                                  }
                                                                } else {
                                                                  _vm.selectAllNorthAmerica =
                                                                    $$c
                                                                }
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.templateIndex =
                                                                  index
                                                              },
                                                            ],
                                                          },
                                                        }),
                                                        _c("span", {
                                                          staticClass: "cr",
                                                        }),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-emergo-dark-blue ft-14 fw-500",
                                                    },
                                                    [_vm._v("Select all")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                _vm._l(
                                                  template.services.usa_fda,
                                                  function (
                                                    service,
                                                    index_service
                                                  ) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index_service,
                                                        staticClass:
                                                          "form-check",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "mb-5",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "checkbox inline-checkbox",
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm
                                                                              .submitData
                                                                              .template_id_list,
                                                                          expression:
                                                                            "submitData.template_id_list",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      type: "checkbox",
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        service.id,
                                                                      checked:
                                                                        Array.isArray(
                                                                          _vm
                                                                            .submitData
                                                                            .template_id_list
                                                                        )
                                                                          ? _vm._i(
                                                                              _vm
                                                                                .submitData
                                                                                .template_id_list,
                                                                              service.id
                                                                            ) >
                                                                            -1
                                                                          : _vm
                                                                              .submitData
                                                                              .template_id_list,
                                                                    },
                                                                    on: {
                                                                      change: [
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          var $$a =
                                                                              _vm
                                                                                .submitData
                                                                                .template_id_list,
                                                                            $$el =
                                                                              $event.target,
                                                                            $$c =
                                                                              $$el.checked
                                                                                ? true
                                                                                : false
                                                                          if (
                                                                            Array.isArray(
                                                                              $$a
                                                                            )
                                                                          ) {
                                                                            var $$v =
                                                                                service.id,
                                                                              $$i =
                                                                                _vm._i(
                                                                                  $$a,
                                                                                  $$v
                                                                                )
                                                                            if (
                                                                              $$el.checked
                                                                            ) {
                                                                              $$i <
                                                                                0 &&
                                                                                _vm.$set(
                                                                                  _vm.submitData,
                                                                                  "template_id_list",
                                                                                  $$a.concat(
                                                                                    [
                                                                                      $$v,
                                                                                    ]
                                                                                  )
                                                                                )
                                                                            } else {
                                                                              $$i >
                                                                                -1 &&
                                                                                _vm.$set(
                                                                                  _vm.submitData,
                                                                                  "template_id_list",
                                                                                  $$a
                                                                                    .slice(
                                                                                      0,
                                                                                      $$i
                                                                                    )
                                                                                    .concat(
                                                                                      $$a.slice(
                                                                                        $$i +
                                                                                          1
                                                                                      )
                                                                                    )
                                                                                )
                                                                            }
                                                                          } else {
                                                                            _vm.$set(
                                                                              _vm.submitData,
                                                                              "template_id_list",
                                                                              $$c
                                                                            )
                                                                          }
                                                                        },
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.resetValues(
                                                                            index,
                                                                            index_service,
                                                                            "usa_fda"
                                                                          )
                                                                        },
                                                                      ],
                                                                    },
                                                                  }),
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "cr",
                                                                  }),
                                                                ]),
                                                              ]
                                                            ),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  service.name
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm.submitData.template_id_list.indexOf(
                                                          service.id
                                                        ) > -1
                                                          ? _vm._l(
                                                              service.questions,
                                                              function (
                                                                question,
                                                                question_index
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key: question_index,
                                                                    staticClass:
                                                                      "row ml-20 questions-row",
                                                                  },
                                                                  [
                                                                    question.type ===
                                                                      "checkbox" &&
                                                                    (!_vm.selectedCountry ||
                                                                      !question.not_for_countries.includes(
                                                                        _vm
                                                                          .selectedCountry
                                                                          .country_name
                                                                      ))
                                                                      ? [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "col-xs-12 pb-10",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "checkbox inline-checkbox",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "label",
                                                                                    [
                                                                                      _c(
                                                                                        "input",
                                                                                        {
                                                                                          directives:
                                                                                            [
                                                                                              {
                                                                                                name: "model",
                                                                                                rawName:
                                                                                                  "v-model",
                                                                                                value:
                                                                                                  question.answer,
                                                                                                expression:
                                                                                                  "question.answer",
                                                                                              },
                                                                                            ],
                                                                                          attrs:
                                                                                            {
                                                                                              type: "checkbox",
                                                                                              "true-value":
                                                                                                "Yes",
                                                                                              "false-value":
                                                                                                "-",
                                                                                            },
                                                                                          domProps:
                                                                                            {
                                                                                              checked:
                                                                                                Array.isArray(
                                                                                                  question.answer
                                                                                                )
                                                                                                  ? _vm._i(
                                                                                                      question.answer,
                                                                                                      null
                                                                                                    ) >
                                                                                                    -1
                                                                                                  : _vm._q(
                                                                                                      question.answer,
                                                                                                      "Yes"
                                                                                                    ),
                                                                                            },
                                                                                          on: {
                                                                                            change:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                var $$a =
                                                                                                    question.answer,
                                                                                                  $$el =
                                                                                                    $event.target,
                                                                                                  $$c =
                                                                                                    $$el.checked
                                                                                                      ? "Yes"
                                                                                                      : "-"
                                                                                                if (
                                                                                                  Array.isArray(
                                                                                                    $$a
                                                                                                  )
                                                                                                ) {
                                                                                                  var $$v =
                                                                                                      null,
                                                                                                    $$i =
                                                                                                      _vm._i(
                                                                                                        $$a,
                                                                                                        $$v
                                                                                                      )
                                                                                                  if (
                                                                                                    $$el.checked
                                                                                                  ) {
                                                                                                    $$i <
                                                                                                      0 &&
                                                                                                      _vm.$set(
                                                                                                        question,
                                                                                                        "answer",
                                                                                                        $$a.concat(
                                                                                                          [
                                                                                                            $$v,
                                                                                                          ]
                                                                                                        )
                                                                                                      )
                                                                                                  } else {
                                                                                                    $$i >
                                                                                                      -1 &&
                                                                                                      _vm.$set(
                                                                                                        question,
                                                                                                        "answer",
                                                                                                        $$a
                                                                                                          .slice(
                                                                                                            0,
                                                                                                            $$i
                                                                                                          )
                                                                                                          .concat(
                                                                                                            $$a.slice(
                                                                                                              $$i +
                                                                                                                1
                                                                                                            )
                                                                                                          )
                                                                                                      )
                                                                                                  }
                                                                                                } else {
                                                                                                  _vm.$set(
                                                                                                    question,
                                                                                                    "answer",
                                                                                                    $$c
                                                                                                  )
                                                                                                }
                                                                                              },
                                                                                          },
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "cr",
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        question.question
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                  question.required
                                                                                    ? _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "required",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "*"
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      : _vm._e(),
                                                                    question.type !==
                                                                      "checkbox" &&
                                                                    (!_vm.selectedCountry ||
                                                                      !question.not_for_countries.includes(
                                                                        _vm
                                                                          .selectedCountry
                                                                          .country_name
                                                                      ))
                                                                      ? [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "col-xs-12 pb-5 pr-0",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    question.question
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                              question.required
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "required",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "*"
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                          question.type ===
                                                                          "dropdown"
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-xs-12 col-sm-8 pr-0",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "multiselect",
                                                                                    {
                                                                                      staticClass:
                                                                                        "multiselect-single-dropdown",
                                                                                      class:
                                                                                        !question.answer
                                                                                          ? "un-selected"
                                                                                          : "",
                                                                                      attrs:
                                                                                        {
                                                                                          placeholder:
                                                                                            "Select Answer",
                                                                                          options:
                                                                                            question.values,
                                                                                          searchable: false,
                                                                                          "allow-empty": false,
                                                                                          showLabels: false,
                                                                                          editable:
                                                                                            "false",
                                                                                        },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            question.answer,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                question,
                                                                                                "answer",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                          expression:
                                                                                            "question.answer",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      : _vm._e(),
                                                                  ],
                                                                  2
                                                                )
                                                              }
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "div",
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.activeTab ===
                                                    "latin_america",
                                                  expression:
                                                    "activeTab === 'latin_america'",
                                                },
                                              ],
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "select_all" },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "checkbox inline-checkbox",
                                                    },
                                                    [
                                                      _c("label", [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.selectAllSouthAmerica,
                                                              expression:
                                                                "selectAllSouthAmerica",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            checked:
                                                              Array.isArray(
                                                                _vm.selectAllSouthAmerica
                                                              )
                                                                ? _vm._i(
                                                                    _vm.selectAllSouthAmerica,
                                                                    null
                                                                  ) > -1
                                                                : _vm.selectAllSouthAmerica,
                                                          },
                                                          on: {
                                                            change: [
                                                              function (
                                                                $event
                                                              ) {
                                                                var $$a =
                                                                    _vm.selectAllSouthAmerica,
                                                                  $$el =
                                                                    $event.target,
                                                                  $$c =
                                                                    $$el.checked
                                                                      ? true
                                                                      : false
                                                                if (
                                                                  Array.isArray(
                                                                    $$a
                                                                  )
                                                                ) {
                                                                  var $$v =
                                                                      null,
                                                                    $$i =
                                                                      _vm._i(
                                                                        $$a,
                                                                        $$v
                                                                      )
                                                                  if (
                                                                    $$el.checked
                                                                  ) {
                                                                    $$i < 0 &&
                                                                      (_vm.selectAllSouthAmerica =
                                                                        $$a.concat(
                                                                          [$$v]
                                                                        ))
                                                                  } else {
                                                                    $$i > -1 &&
                                                                      (_vm.selectAllSouthAmerica =
                                                                        $$a
                                                                          .slice(
                                                                            0,
                                                                            $$i
                                                                          )
                                                                          .concat(
                                                                            $$a.slice(
                                                                              $$i +
                                                                                1
                                                                            )
                                                                          ))
                                                                  }
                                                                } else {
                                                                  _vm.selectAllSouthAmerica =
                                                                    $$c
                                                                }
                                                              },
                                                              function (
                                                                $event
                                                              ) {
                                                                _vm.templateIndex =
                                                                  index
                                                              },
                                                            ],
                                                          },
                                                        }),
                                                        _c("span", {
                                                          staticClass: "cr",
                                                        }),
                                                      ]),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "text-emergo-dark-blue ft-14 fw-500",
                                                    },
                                                    [_vm._v("Select all")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "div",
                                                { staticClass: "col-md-12" },
                                                _vm._l(
                                                  template.services
                                                    .latin_america,
                                                  function (
                                                    service,
                                                    index_service
                                                  ) {
                                                    return _c(
                                                      "div",
                                                      {
                                                        key: index_service,
                                                        staticClass:
                                                          "form-check",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass: "mb-5",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "checkbox inline-checkbox",
                                                              },
                                                              [
                                                                _c("label", [
                                                                  _c("input", {
                                                                    directives:
                                                                      [
                                                                        {
                                                                          name: "model",
                                                                          rawName:
                                                                            "v-model",
                                                                          value:
                                                                            _vm
                                                                              .submitData
                                                                              .template_id_list,
                                                                          expression:
                                                                            "submitData.template_id_list",
                                                                        },
                                                                      ],
                                                                    attrs: {
                                                                      type: "checkbox",
                                                                    },
                                                                    domProps: {
                                                                      value:
                                                                        service.id,
                                                                      checked:
                                                                        Array.isArray(
                                                                          _vm
                                                                            .submitData
                                                                            .template_id_list
                                                                        )
                                                                          ? _vm._i(
                                                                              _vm
                                                                                .submitData
                                                                                .template_id_list,
                                                                              service.id
                                                                            ) >
                                                                            -1
                                                                          : _vm
                                                                              .submitData
                                                                              .template_id_list,
                                                                    },
                                                                    on: {
                                                                      change: [
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          var $$a =
                                                                              _vm
                                                                                .submitData
                                                                                .template_id_list,
                                                                            $$el =
                                                                              $event.target,
                                                                            $$c =
                                                                              $$el.checked
                                                                                ? true
                                                                                : false
                                                                          if (
                                                                            Array.isArray(
                                                                              $$a
                                                                            )
                                                                          ) {
                                                                            var $$v =
                                                                                service.id,
                                                                              $$i =
                                                                                _vm._i(
                                                                                  $$a,
                                                                                  $$v
                                                                                )
                                                                            if (
                                                                              $$el.checked
                                                                            ) {
                                                                              $$i <
                                                                                0 &&
                                                                                _vm.$set(
                                                                                  _vm.submitData,
                                                                                  "template_id_list",
                                                                                  $$a.concat(
                                                                                    [
                                                                                      $$v,
                                                                                    ]
                                                                                  )
                                                                                )
                                                                            } else {
                                                                              $$i >
                                                                                -1 &&
                                                                                _vm.$set(
                                                                                  _vm.submitData,
                                                                                  "template_id_list",
                                                                                  $$a
                                                                                    .slice(
                                                                                      0,
                                                                                      $$i
                                                                                    )
                                                                                    .concat(
                                                                                      $$a.slice(
                                                                                        $$i +
                                                                                          1
                                                                                      )
                                                                                    )
                                                                                )
                                                                            }
                                                                          } else {
                                                                            _vm.$set(
                                                                              _vm.submitData,
                                                                              "template_id_list",
                                                                              $$c
                                                                            )
                                                                          }
                                                                        },
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.resetValues(
                                                                            index,
                                                                            index_service,
                                                                            "latin_america"
                                                                          )
                                                                        },
                                                                      ],
                                                                    },
                                                                  }),
                                                                  _c("span", {
                                                                    staticClass:
                                                                      "cr",
                                                                  }),
                                                                ]),
                                                              ]
                                                            ),
                                                            _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  service.name
                                                                )
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                        _vm.submitData.template_id_list.indexOf(
                                                          service.id
                                                        ) > -1
                                                          ? _vm._l(
                                                              service.questions,
                                                              function (
                                                                question,
                                                                question_index
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key: question_index,
                                                                    staticClass:
                                                                      "row ml-20 questions-row",
                                                                  },
                                                                  [
                                                                    question.type ===
                                                                      "checkbox" &&
                                                                    (!_vm.selectedCountry ||
                                                                      !question.not_for_countries.includes(
                                                                        _vm
                                                                          .selectedCountry
                                                                          .country_name
                                                                      ))
                                                                      ? [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "col-xs-12 pb-10",
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "checkbox",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "label",
                                                                                    [
                                                                                      _c(
                                                                                        "input",
                                                                                        {
                                                                                          directives:
                                                                                            [
                                                                                              {
                                                                                                name: "model",
                                                                                                rawName:
                                                                                                  "v-model",
                                                                                                value:
                                                                                                  question.answer,
                                                                                                expression:
                                                                                                  "question.answer",
                                                                                              },
                                                                                            ],
                                                                                          attrs:
                                                                                            {
                                                                                              type: "checkbox",
                                                                                              "true-value":
                                                                                                "Yes",
                                                                                              "false-value":
                                                                                                "-",
                                                                                            },
                                                                                          domProps:
                                                                                            {
                                                                                              checked:
                                                                                                Array.isArray(
                                                                                                  question.answer
                                                                                                )
                                                                                                  ? _vm._i(
                                                                                                      question.answer,
                                                                                                      null
                                                                                                    ) >
                                                                                                    -1
                                                                                                  : _vm._q(
                                                                                                      question.answer,
                                                                                                      "Yes"
                                                                                                    ),
                                                                                            },
                                                                                          on: {
                                                                                            change:
                                                                                              function (
                                                                                                $event
                                                                                              ) {
                                                                                                var $$a =
                                                                                                    question.answer,
                                                                                                  $$el =
                                                                                                    $event.target,
                                                                                                  $$c =
                                                                                                    $$el.checked
                                                                                                      ? "Yes"
                                                                                                      : "-"
                                                                                                if (
                                                                                                  Array.isArray(
                                                                                                    $$a
                                                                                                  )
                                                                                                ) {
                                                                                                  var $$v =
                                                                                                      null,
                                                                                                    $$i =
                                                                                                      _vm._i(
                                                                                                        $$a,
                                                                                                        $$v
                                                                                                      )
                                                                                                  if (
                                                                                                    $$el.checked
                                                                                                  ) {
                                                                                                    $$i <
                                                                                                      0 &&
                                                                                                      _vm.$set(
                                                                                                        question,
                                                                                                        "answer",
                                                                                                        $$a.concat(
                                                                                                          [
                                                                                                            $$v,
                                                                                                          ]
                                                                                                        )
                                                                                                      )
                                                                                                  } else {
                                                                                                    $$i >
                                                                                                      -1 &&
                                                                                                      _vm.$set(
                                                                                                        question,
                                                                                                        "answer",
                                                                                                        $$a
                                                                                                          .slice(
                                                                                                            0,
                                                                                                            $$i
                                                                                                          )
                                                                                                          .concat(
                                                                                                            $$a.slice(
                                                                                                              $$i +
                                                                                                                1
                                                                                                            )
                                                                                                          )
                                                                                                      )
                                                                                                  }
                                                                                                } else {
                                                                                                  _vm.$set(
                                                                                                    question,
                                                                                                    "answer",
                                                                                                    $$c
                                                                                                  )
                                                                                                }
                                                                                              },
                                                                                          },
                                                                                        }
                                                                                      ),
                                                                                      _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "cr",
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _c(
                                                                                "span",
                                                                                [
                                                                                  _vm._v(
                                                                                    " " +
                                                                                      _vm._s(
                                                                                        question.question
                                                                                      ) +
                                                                                      " "
                                                                                  ),
                                                                                  question.required
                                                                                    ? _c(
                                                                                        "span",
                                                                                        {
                                                                                          staticClass:
                                                                                            "required",
                                                                                        },
                                                                                        [
                                                                                          _vm._v(
                                                                                            "*"
                                                                                          ),
                                                                                        ]
                                                                                      )
                                                                                    : _vm._e(),
                                                                                ]
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      : _vm._e(),
                                                                    question.type !==
                                                                      "checkbox" &&
                                                                    (!_vm.selectedCountry ||
                                                                      !question.not_for_countries.includes(
                                                                        _vm
                                                                          .selectedCountry
                                                                          .country_name
                                                                      ))
                                                                      ? [
                                                                          _c(
                                                                            "div",
                                                                            {
                                                                              staticClass:
                                                                                "col-xs-12 pb-5 pr-0",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                " " +
                                                                                  _vm._s(
                                                                                    question.question
                                                                                  ) +
                                                                                  " "
                                                                              ),
                                                                              question.required
                                                                                ? _c(
                                                                                    "span",
                                                                                    {
                                                                                      staticClass:
                                                                                        "required",
                                                                                    },
                                                                                    [
                                                                                      _vm._v(
                                                                                        "*"
                                                                                      ),
                                                                                    ]
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          ),
                                                                          question.type ===
                                                                          "dropdown"
                                                                            ? _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "col-xs-12 col-sm-8 pr-0",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "multiselect",
                                                                                    {
                                                                                      staticClass:
                                                                                        "multiselect-single-dropdown",
                                                                                      class:
                                                                                        !question.answer
                                                                                          ? "un-selected"
                                                                                          : "",
                                                                                      attrs:
                                                                                        {
                                                                                          placeholder:
                                                                                            "Select Answer",
                                                                                          options:
                                                                                            question.values,
                                                                                          searchable: false,
                                                                                          "allow-empty": false,
                                                                                          showLabels: false,
                                                                                          editable:
                                                                                            "false",
                                                                                        },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            question.answer,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                question,
                                                                                                "answer",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                          expression:
                                                                                            "question.answer",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              )
                                                                            : _vm._e(),
                                                                        ]
                                                                      : _vm._e(),
                                                                  ],
                                                                  2
                                                                )
                                                              }
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    )
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                        ],
                                        2
                                      ),
                                      _vm.showDefaultQuestions(
                                        template.services
                                      ) && template.common_questions.length
                                        ? _c(
                                            "div",
                                            { staticClass: "col-xs-12" },
                                            _vm._l(
                                              template.common_questions,
                                              function (
                                                question,
                                                index_common
                                              ) {
                                                return _c(
                                                  "div",
                                                  {
                                                    key: index_common,
                                                    staticClass:
                                                      "row questions-row m-0",
                                                  },
                                                  [
                                                    question.type ===
                                                      "checkbox" &&
                                                    (!_vm.selectedCountry ||
                                                      !question.not_for_countries.includes(
                                                        _vm.selectedCountry
                                                          .country_name
                                                      ))
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-xs-12 checkbox-block pb-10",
                                                            },
                                                            [
                                                              _c("input", {
                                                                directives: [
                                                                  {
                                                                    name: "model",
                                                                    rawName:
                                                                      "v-model",
                                                                    value:
                                                                      question.answer,
                                                                    expression:
                                                                      "question.answer",
                                                                  },
                                                                ],
                                                                attrs: {
                                                                  type: "checkbox",
                                                                  "true-value":
                                                                    "Yes",
                                                                  "false-value":
                                                                    "-",
                                                                },
                                                                domProps: {
                                                                  checked:
                                                                    Array.isArray(
                                                                      question.answer
                                                                    )
                                                                      ? _vm._i(
                                                                          question.answer,
                                                                          null
                                                                        ) > -1
                                                                      : _vm._q(
                                                                          question.answer,
                                                                          "Yes"
                                                                        ),
                                                                },
                                                                on: {
                                                                  change:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      var $$a =
                                                                          question.answer,
                                                                        $$el =
                                                                          $event.target,
                                                                        $$c =
                                                                          $$el.checked
                                                                            ? "Yes"
                                                                            : "-"
                                                                      if (
                                                                        Array.isArray(
                                                                          $$a
                                                                        )
                                                                      ) {
                                                                        var $$v =
                                                                            null,
                                                                          $$i =
                                                                            _vm._i(
                                                                              $$a,
                                                                              $$v
                                                                            )
                                                                        if (
                                                                          $$el.checked
                                                                        ) {
                                                                          $$i <
                                                                            0 &&
                                                                            _vm.$set(
                                                                              question,
                                                                              "answer",
                                                                              $$a.concat(
                                                                                [
                                                                                  $$v,
                                                                                ]
                                                                              )
                                                                            )
                                                                        } else {
                                                                          $$i >
                                                                            -1 &&
                                                                            _vm.$set(
                                                                              question,
                                                                              "answer",
                                                                              $$a
                                                                                .slice(
                                                                                  0,
                                                                                  $$i
                                                                                )
                                                                                .concat(
                                                                                  $$a.slice(
                                                                                    $$i +
                                                                                      1
                                                                                  )
                                                                                )
                                                                            )
                                                                        }
                                                                      } else {
                                                                        _vm.$set(
                                                                          question,
                                                                          "answer",
                                                                          $$c
                                                                        )
                                                                      }
                                                                    },
                                                                },
                                                              }),
                                                              _c("span", [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      question.question
                                                                    ) +
                                                                    " "
                                                                ),
                                                                question.required
                                                                  ? _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "required",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "*"
                                                                        ),
                                                                      ]
                                                                    )
                                                                  : _vm._e(),
                                                              ]),
                                                            ]
                                                          ),
                                                        ]
                                                      : _vm._e(),
                                                    question.type !==
                                                      "checkbox" &&
                                                    (!_vm.selectedCountry ||
                                                      !question.not_for_countries.includes(
                                                        _vm.selectedCountry
                                                          .country_name
                                                      ))
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-xs-12 pb-5",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    question.question
                                                                  ) +
                                                                  " "
                                                              ),
                                                              question.required
                                                                ? _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "required",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "*"
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ]
                                                          ),
                                                          question.type ===
                                                          "dropdown"
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "col-xs-12 col-sm-8",
                                                                },
                                                                [
                                                                  _c(
                                                                    "multiselect",
                                                                    {
                                                                      staticClass:
                                                                        "multiselect-single-dropdown",
                                                                      class:
                                                                        !question.answer
                                                                          ? "un-selected"
                                                                          : "",
                                                                      attrs: {
                                                                        placeholder:
                                                                          "Select Answer",
                                                                        options:
                                                                          question.values,
                                                                        searchable: false,
                                                                        "allow-empty": false,
                                                                        showLabels: false,
                                                                        editable:
                                                                          "false",
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          question.answer,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              question,
                                                                              "answer",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "question.answer",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                )
                                              }
                                            ),
                                            0
                                          )
                                        : _vm._e(),
                                    ]
                                  )
                                }
                              ),
                              _c("div", { staticClass: "form-group" }, [
                                _vm._m(2),
                                _c("textarea", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.comment,
                                      expression: "comment",
                                    },
                                  ],
                                  staticClass: "form-control",
                                  attrs: { rows: "4" },
                                  domProps: { value: _vm.comment },
                                  on: {
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.comment = $event.target.value
                                    },
                                  },
                                }),
                              ]),
                            ],
                            2
                          ),
                        ]),
                      ]
                    : [_vm._m(3)],
                ],
                2
              ),
              _vm.body_text === "default"
                ? _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn emergo-green-button",
                        attrs: { type: "button", disabled: _vm.disableSubmit },
                        on: {
                          click: function ($event) {
                            return _vm.requestService()
                          },
                        },
                      },
                      [_vm._v(" Submit ")]
                    ),
                  ])
                : _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn emergo-blue-button",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.reset()
                          },
                        },
                      },
                      [_vm._v("OK")]
                    ),
                  ]),
            ]),
            _c("loader", { attrs: { loadingStatus: _vm.loaderStatus } }),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("h3", { staticClass: "confirm_title" }, [_vm._v("Quote Request")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "pb-8" }, [
      _vm._v(" Where are you located? "),
      _c("span", { staticClass: "required" }, [_vm._v("*")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "country-header" }, [
      _vm._v(" Comments "),
      _c("span", { staticStyle: { color: "rgb(0, 0, 0, 0.5)" } }, [
        _vm._v("(optional)"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "p-confirm" }, [
      _c("div", [
        _c("img", {
          staticClass: "check_img",
          attrs: {
            src: "/static/images/icons/check_icon.svg",
            alt: "check-icon",
          },
        }),
        _c("h3", { staticClass: "confirm_title" }, [
          _vm._v("Thanks for your request!"),
        ]),
      ]),
      _c("div", [_vm._v("Our Sales Team will contact you soon.")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }